import styled from "styled-components";

export const SAddProjectModalSectionsContainer = styled.div`
  /* padding: 24px; */
  width: 784px;
  background-color: var(--ui-01);
  border-radius: 12px;
  border: 1px solid var(--ui-03);
`;
